import { Component, OnInit, OnDestroy, Inject } from "@angular/core";
import {
  JhaPubSubService,
  JhaPubSubMessage,
} from "@jkhy/responsive-ui-angular/jha-responsive-core";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { DataService } from "../../services/data.service";
import { PFrameRoutes } from "../../shared/pframe-routes";
import { Institution } from "src/app/shared/models/institution.model";

@Component({
  selector: "main-header",
  templateUrl: "./main-header.component.html",
  styleUrls: ["./main-header.component.scss"]
})
export class MainHeaderComponent implements OnInit, OnDestroy {
  public hideHeader = false;
  public displayBackButton = false;
  public hideNav = false;
  public loggedIn = false;
  private subscriptions: Subscription[] = [];
  public wksList = [];
  public currentWKSInst: any;

  constructor(
    @Inject(JhaPubSubService) private pubSubService: JhaPubSubService,
    private router: Router,
    private dataService: DataService
  ) {}

  backButtonClicked(): void {
    window.history.back();
  }
  public ngOnInit(): void {
    this.subscriptions.push(
      this.pubSubService.Stream.subscribe((pubSubMessage) =>
        this.processMessage(pubSubMessage)
      )
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  public processMessage(pubSubMessage: JhaPubSubMessage): void {
    if (pubSubMessage.message === "LoggedIn") {
      this.loggedIn = true;
    } else if (pubSubMessage.message === "LoggedOut") {
      this.loggedIn = false;
    } else if (pubSubMessage.message === "UserProfile") {
      this.wksList = this.dataService.getWKSList();
      this.currentWKSInst = this.dataService.getCurrentInst();
    } else if (pubSubMessage.message === "InstitutionChanged") {
      this.currentWKSInst = this.dataService.getCurrentInst();
    }
  }

  public logOut() {
    this.pubSubService.Stream.next(new JhaPubSubMessage("ShowLogOutDialog", null));
  }

  public switchWks(inst: Institution) {
    if (inst.institutionId === this.currentWKSInst) {
      return;
    } else {
      this.pubSubService.Stream.next(new JhaPubSubMessage("ShowInstitutionSwitchDialog", inst));
    }
  }

  public openPattern(url: string): void {
    const win = window.open(url, "_blank");
    win.focus();
  }
  public showUserProfile(): void {
    this.router.navigate([PFrameRoutes.userProfile]);
  }
}
